import useRoundup, { roundupConfigs } from './useRoundup'

export const configs = {
  roundup: roundupConfigs,
}

export const api = {
  roundup: useRoundup,
}
